module.exports = __webpack_public_path__ + "static/media/iphone_14_space_black_pro.59e705d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_space_black_pro.jpg
// module id = 2137
// module chunks = 0